import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { useTrpc } from '~/composables/_next/useTrpc';
import { isPreview } from '~/utils';

/**
 * This middleware aims to solve issues linked to contentful live preview
 */
export default defineNuxtRouteMiddleware(/*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(to) {
    var _useNuxt2App, locale, route, fetchProductListingSlugForLocale, _useTrpc, client, localeSlug;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (isPreview()) {
            _context2.next = 2;
            break;
          }
          return _context2.abrupt("return");
        case 2:
          _useNuxt2App = useNuxt2App(), locale = _useNuxt2App.i18n.locale;
          route = useRoute();
          if (!(to.query.live_preview_plp_internalName === 'true')) {
            _context2.next = 11;
            break;
          }
          fetchProductListingSlugForLocale = /*#__PURE__*/function () {
            var _ref2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
              var params, results, slugLocales, allSlugs;
              return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    params = route.params;
                    _context.next = 3;
                    return client.commercetools.getCategoryMetaTags.query({
                      slug: params === null || params === void 0 ? void 0 : params.slug,
                      locale: 'fr'
                    });
                  case 3:
                    results = _context.sent;
                    slugLocales = results[0] ? Object.keys(results[0]).filter(function (item) {
                      return item.substring(0, 5) === 'slug_';
                    }) : [];
                    allSlugs = slugLocales.reduce(function (map, slugKey) {
                      var fragments = results.filter(function (item) {
                        return item === null || item === void 0 ? void 0 : item[slugKey];
                      }).map(function (item) {
                        return item[slugKey];
                      });
                      return _objectSpread(_objectSpread({}, map), {}, _defineProperty({}, slugKey.substring(5), fragments.join('/')));
                    }, {});
                    return _context.abrupt("return", allSlugs[locale]);
                  case 7:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
            return function fetchProductListingSlugForLocale() {
              return _ref2.apply(this, arguments);
            };
          }();
          // contentful preview does not know commercetools' categories slugs, only internal name (which is the slug in french), internalName is a query parameter added on livepreview urls for PLPs
          // example of url handled here : /de/products/huiles-essentielles?live_preview_plp_internalName=true
          _useTrpc = useTrpc(), client = _useTrpc.client;
          _context2.next = 9;
          return fetchProductListingSlugForLocale();
        case 9:
          localeSlug = _context2.sent;
          return _context2.abrupt("return", navigateTo("".concat(locale === 'fr' ? '' : '/' + locale, "/products/").concat(localeSlug)));
        case 11:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());